<app-page-layout [pageTitle]="'Reporte de Carga Masiva'">
  <div page-content class="page-content">
    <div class="report-container">
      <div class="report-card">
        <!-- Back navigation tag -->
        <a class="back-tag" routerLink="/">
          <i class="pi pi-arrow-left"></i>
          Nueva Carga
        </a>

        <!-- Error state -->
        @if (error()) {
          <app-report-error-card
            [title]="errorTitle()"
            [message]="error()!"
            [isRetrying]="isRefreshing()"
            (retry)="refreshTable()"
            (cleared)="clearError()"
          />
        }

        <!-- Delete confirmation successfull -->
        @if (deletedLoadId()) {
          <app-report-delete-success-card
            [loadId]="deletedLoadId()!"
            [policyNumber]="deletedPolicyNumber() ?? ''"
            (cleared)="clearDeleteSuccess()"
          />
        }

        <!-- Filter toolbar -->
        <app-report-filter-bar
          [filterMode]="filterMode()"
          [filterText]="filterText()"
          [isLoading]="isLoading()"
          [isRefreshing]="isRefreshing()"
          (filterModeChange)="setFilterMode($event)"
          (filterTextChange)="onFilterChange($event)"
          (search)="applyFilter()"
          (refresh)="refreshTable()"
          (reset)="resetFilters()"
        />

        <!-- Table -->
        <app-report-table
          [loads]="loads()"
          [isLoading]="isLoading()"
          [isRefreshing]="isRefreshing()"
          [deletingLoadId]="deletingLoadId()"
          [rowsPerPage]="rowsPerPage()"
          [currentPage]="currentPage()"
          [totalRecords]="totalRecords()"
          [rowsPerPageOptions]="rowsPerPageOptions"
          (pageChange)="onPageChange($event)"
          (deleteLoad)="deleteLoad($event)"
        />
      </div>
    </div>
  </div>
</app-page-layout>
